import { UserPreference } from './__generated__/sdk';

export function filterOnlySupportedUserPreferences(userPreferences: UserPreference[]): UserPreference[] {
  const preferenceCategoryNameWhiteList = ['NewProjectsMarketing', 'MyProjectsUpdates', 'Personalized'];
  return userPreferences.filter(({ preferenceCategoryName }) =>
    preferenceCategoryNameWhiteList.includes(preferenceCategoryName)
  );
}
